import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ReservationAreaManagement from '@/types/table/reservationAreaManagement';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ReservationAreaManagementData extends ReservationAreaManagement {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ReservationAreaManagementController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ReservationAreaManagementData>>(API_CONTEXT + '/app/reservationAreaManagement/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ReservationAreaManagementData>(API_CONTEXT + '/app/reservationAreaManagement/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/reservationAreaManagement/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/reservationAreaManagement/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/reservationAreaManagement/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationAreaManagement/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationAreaManagement/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationAreaManagement/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/reservationAreaManagement/deleteBatch', params, httpOptions);
  }
}
